import { forwardRef, memo } from "react";

export const SMSSearchIcon = memo(
  forwardRef(function SMSSearchIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M11.3241 20.0528H6.60574C3.16138 20.0528 1.17969 18.0711 1.17969 14.6268V8.02115C1.17969 4.57678 3.16138 2.59509 6.60574 2.59509H16.0424C19.4867 2.59509 21.4684 4.57678 21.4684 8.02115V10.8521C21.4684 11.239 21.1476 11.5599 20.7607 11.5599C20.3738 11.5599 20.0529 11.239 20.0529 10.8521V8.02115C20.0529 5.32228 18.7412 4.01059 16.0424 4.01059H6.60574C3.90687 4.01059 2.59518 5.32228 2.59518 8.02115V14.6268C2.59518 17.3257 3.90687 18.6373 6.60574 18.6373H11.3241C11.711 18.6373 12.0318 18.9582 12.0318 19.3451C12.0318 19.732 11.711 20.0528 11.3241 20.0528Z"
          fill={color}
        />
        <path
          d="M11.3231 12.1449C10.5305 12.1449 9.72836 11.8995 9.11498 11.3994L6.16131 9.04022C5.85934 8.79487 5.80272 8.35136 6.04808 8.04939C6.29343 7.74742 6.73694 7.70024 7.03891 7.93615L9.99258 10.2953C10.7098 10.8709 11.9271 10.8709 12.6443 10.2953L15.5979 7.93615C15.8999 7.6908 16.3434 7.73798 16.5888 8.04939C16.8341 8.35136 16.7869 8.80431 16.4755 9.04022L13.5219 11.3994C12.9179 11.8995 12.1158 12.1449 11.3231 12.1449Z"
          fill={color}
        />
        <path
          d="M17.1728 20.9021C15.1156 20.9021 13.4453 19.2319 13.4453 17.1747C13.4453 15.1175 15.1156 13.4472 17.1728 13.4472C19.23 13.4472 20.9002 15.1175 20.9002 17.1747C20.9002 19.2319 19.23 20.9021 17.1728 20.9021ZM17.1728 14.8627C15.8988 14.8627 14.8608 15.9007 14.8608 17.1747C14.8608 18.4486 15.8988 19.4866 17.1728 19.4866C18.4467 19.4866 19.4847 18.4486 19.4847 17.1747C19.4847 15.9007 18.4467 14.8627 17.1728 14.8627Z"
          fill={color}
        />
        <path
          d="M20.7623 21.4683C20.583 21.4683 20.4037 21.4022 20.2622 21.2607L19.3185 20.317C19.0449 20.0434 19.0449 19.5904 19.3185 19.3168C19.5922 19.0431 20.0451 19.0431 20.3188 19.3168L21.2625 20.2604C21.5361 20.5341 21.5361 20.987 21.2625 21.2607C21.1209 21.4022 20.9416 21.4683 20.7623 21.4683Z"
          fill={color}
        />
      </svg>
    );
  }),
);

SMSSearchIcon.displayName = "SMSSearchIcon";